import { adminHttpClient } from '../commons/adminHttpClient'

const getEENotice = (): Promise<string> => {
  return adminHttpClient.get(`Employees/ichra/ee-notice/my`)
}

export default getEENotice
